<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de classificação de risco">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-classificacao-risco/List'

export default {
    components: {
        List,
    },
}
</script>